const copy = {
  automatedUserResponse: "Provide feedback on live chat",
  errors: {
    toast: "Something went wrong. Try again.",
    emptyState: {
      heading: (displayName: string) =>
        `We could not load the ${displayName} survey`,
      description: 'Click "Retry" to try again.',
    },
  },
  formButton: {
    cancel: "Cancel",
    submit: "Submit feedback",
    retry: "Retry",
  },
  feedbackSubmitted: "Feedback submitted",
};

export default copy;
